import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HomePage } from '../home/home.page';
import { MenuPage } from '../menu/menu.page';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/services/navigation.service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-tos',
	templateUrl: './tos.page.html',
	styleUrls: ['tos.page.scss'],
})
export class TosPage {
	static url = 'tos';
	environment = environment;
	constructor(
		private repository: RepositoryService,
		private navigationService: NavigationService,
		private location: Location,
		public translate: TranslateService
	) {}
	async goBack() {
		if (this.location) {
			this.location.back();
			return;
		}
		if (this.repository._order === null) {
			await this.navigationService.home();
		} else {
			await this.navigationService.menu();
		}
	}
}
